<template>
  <MeetingsPage />
</template>
